/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import { changeBrowserTabTitle } from "../../slices/browserTabTitle/browserTabTitleSlice";
import { Segment } from "semantic-ui-react";
import { useNavigate, useParams } from "react-router-dom";
import { changeFoiFocus, selectFoiFocus } from "../../slices/foiOfFocus/foiOfFocusSlice";
import getFoiFromFli from "../../functions/getFoiFromFliAPI";
import getFhirJson from "../../functions/getFhirJsonAPI";
import { fetchResourceCollection, selectAllResources, selectResourceById, selectResourceCollectionStatus } from "../../slices/resourceCollection/resourceCollectionSlice";
import { changeComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import { HealthImpactForestPlotEnhancedForUser } from "./HealthImpactForestPlotEnhanced";
import ColorSchemeToggle from "../../components/ColorSchemeToggle";
import SummaryOfNetEffectTableForUser from "./SummaryOfNetEffectTableForUser";
import { changeTool } from "../../slices/footer/footerSlice";
import { DisplayFromFHIRMarkdown } from "../../datatypeComponents/MarkdownEntry";

const tryNavigateByFli = async (fli, apiToken, navigate, dispatch) => {
    let response = await getFoiFromFli(fli, apiToken);
    if (response?.success && response.formstateid) {
        dispatch(changeFoiFocus(response.formstateid.toString()));
        navigate("/NetBenefitCalculator/" + response.formstateid, { replace: true });
    } else {
        navigate("/pagenotfound");
    }
}

const loadTheFhirJson = async (FOI, apiToken = null, dispatch, navigate) => {
    let fhirJson = await getFhirJson(FOI, null, apiToken);
    if (fhirJson && typeof fhirJson === "object" && fhirJson.id) { //Added fhirJson.id in this condition on November 18, 2025
        const resourceType = fhirJson.resourceType;
        if (resourceType === "Composition") {
            if (fhirJson.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/summary-of-net-effect") {
                let body = { fhirJson: fhirJson };
                dispatch(fetchResourceCollection(body));
            } else {
                alert("The profile is not SummaryOfNetEffect.");
                navigate("/search");
            }
        } else {
            alert("The resourceType is not Composition.");
            navigate("/search");
        }
    } else if (fhirJson === null) { //Don't have permission to view the resource
        alert("You do not have permission to view this resource.");
        navigate("/search"); //This is different from how it's on current FEvIR, you'd be still on the resource viewer page
    } else if (fhirJson && !fhirJson.id) {
        alert('This Resource doesn\'t have an "id" element in the JSON.');
        navigate("/search");
    } else {
        alert("No Resource found for that FOI.");
        //navigate("/");  //Would navigate(0); make more sense? //This isn't needed I believe
        navigate("/search"); //This is different from how it's on current FEvIR, on current FEvIR it's the resource page with "Resource not found"
    }
};

// eslint-disable-next-line no-empty-pattern
const NetBenefitCalculatorForUser = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { foi } = useParams();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const foiFocus = useSelector(selectFoiFocus);
    const resourceCollectionStatus = useSelector(selectResourceCollectionStatus);
    const resourceCollection = useSelector(state => selectAllResources(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foiFocus));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [netEffectEstimateSectionState, setNetEffectEstimateSectionState] = useState({});
    const [remountTable, setRemountTable] = useState(0);
    const [introductionState, setIntroductionState] = useState("");
    const [citeAsState, setCiteAsState] = useState("");

    useEffect(() => {
        dispatch(changeBrowserTabTitle("Net Benefit Calculator"));
        dispatch(changeTool("Computable Publishing®: Net Benefit Calculator"));
        if (foi) {
            if (!isNaN(foi)) {
                dispatch(changeFoiFocus(foi));
            } else {
                tryNavigateByFli(foi, apiToken, navigate, dispatch);
            }
        }
    }, []);

    useEffect(() => {
        if (foiFocus && !isNaN(foiFocus)) {
            loadTheFhirJson(foiFocus, apiToken, dispatch, navigate);
        }
    }, [foiFocus]);

    useEffect(() => {
        if (resourceCollectionStatus === "succeeded") {
            let combinedDictionary = {};
            for (const entry of resourceCollection) {
                combinedDictionary[entry.id] = entry.revisedResourceJson;
            }
            if (Array.isArray(resourceJson?.contained) && resourceJson.contained.length > 0) {
                for (const item of resourceJson.contained) {
                    combinedDictionary[item.id] = item;
                }
            }
            let body = {
                "compositionId": foi,
                "compositionTitle": resourceJson.title || resourceJson.name || parentResourceDetail.displayTitle,
                "researchStudyReference": {},
                "populationReference": {},
                "populationDescriptionGroupReference": {},
                "analyzedGroupReference": {},
                "enrolledGroupReference": {},
                "interventionGroupReference": {},
                "interventionDescriptionReference": {},
                "comparatorGroupReference": {},
                "comparatorDescriptionReference": {},
                "groupAssignmentReference": {},
                "synthesisPopulationReference": {},
                "synthesisInterventionDescriptionReference": {},
                "synthesisComparatorDescriptionReference": {},
                "screenedGroupReference": {},
                "excludedGroupReference": {},
                "groupReferencesDictionary": {},
                "outcomeMeasuresReportReference": {},
                "participantFlowReportReference": {},
                "baselineMeasuresReportReference": {},
                "summaryOfFindingsReference": {},
                "outcomeMeasures": [],
                "baselineMeasures": [],
                "participantFlowMeasures": [],
                "outcomeVariablesListReference": {},
                "participantFlowVariablesListReference": {},
                "baselineVariablesListReference": {},
                "combinedDictionary": combinedDictionary,
                "evidenceDisplayDictionary": {}
            };
            dispatch(changeComparativeEvidenceMap(body));
            if (Array.isArray(resourceJson?.relatesTo)) {
                for (const relatesTo of resourceJson.relatesTo) {
                    console.log(relatesTo)
                    if (relatesTo.type?.text === "Introduction for Net Benefit Calculator") {
                        let introduction = relatesTo.targetMarkdown || "";
                        setIntroductionState(introduction);
                    }
                    if (relatesTo.type?.coding?.[0]?.code === "cite-as") {
                        let citeAs = relatesTo.targetMarkdown || "";
                        setCiteAsState(citeAs);
                    }
                }
            }
        }
    }, [resourceCollectionStatus]);


    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {apiToken ?
                <>
                    {foi ?
                        <div style={{ marginTop: "12px" }}>
                            {(resourceCollectionStatus === "succeeded") &&
                                <>
                                    <h3 id="introduction">Introduction</h3>
                                    <div style={{ marginLeft: "24px" }}>
                                        {introductionState &&
                                            <DisplayFromFHIRMarkdown markdown={introductionState} />
                                        }
                                        <p>Rate Relative Importance to set the importance rating values to your values.</p>
                                    </div>
                                    <h3 id="summary-table">Summary Table</h3>
                                    {resourceJson &&
                                        <SummaryOfNetEffectTableForUser key={remountTable}
                                            resourceJson={resourceJson} setRemountTable={setRemountTable}
                                            netEffectEstimateSectionState={netEffectEstimateSectionState}
                                            setNetEffectEstimateSectionState={setNetEffectEstimateSectionState} />
                                    }
                                    <br />
                                    <ColorSchemeToggle />
                                    <br />
                                    <HealthImpactForestPlotEnhancedForUser key={remountTable + "Forest"}
                                        netEffectEstimateSection={netEffectEstimateSectionState} />
                                    {citeAsState &&
                                        <span>Source: <DisplayFromFHIRMarkdown markdown={citeAsState} /></span>
                                    }
                                </>}
                        </div>
                        :
                        <p>The Net Benefit Calculator function expects an identifier (FOI) for specific use.</p>
                    }
                </>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
        </Segment>
    </div>
}

export default NetBenefitCalculatorForUser;